import Vue from 'vue'
import store from '../store/index'
import moment from 'moment-timezone'

Vue.filter('datetime', function (value, timeFormat) {
  if (!value) return ''
  
  return moment(value).tz(store.getters['auth/user'].business.timezone).format(timeFormat)
})
